import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import eidWish from "../../images/eidWish.jpg";
import pkFlag from "../../images/pkFlag.webp";

export const NoticeModal = () => {
  const location = useLocation();

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const accept = () => {
    localStorage.setItem("disclaimer", true);
    handleCloseMore();
  };

  useEffect(() => {
    // let check = localStorage.getItem("disclaimer");
    if (
      location.pathname.includes("/admin") ||
      location.pathname.includes("admin-login") ||
      location.pathname.includes("super-admin-login") ||
      location.pathname.includes("waqar-login")
    ) {
    } else {
      handleShowMore();
    }

    // if (check == "true") {
    // } else {
    //   handleShowMore();
    // }
  }, []);

  return (
    <Modal show={showMore} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleCloseMore}>
            <i className="fa-solid fa-xmark" />
          </div>

          <div className="showMoreModalM">
            <div className="showMoreModal">
              {/* <div className="eidModalImg">
                <img src={eidWish} alt="eid mubarak" />
              </div> */}
              {/* <h4 className="mt-3 text-center">Public Announcement</h4> */}
              <h4 className="mb-3 text-center">📢 Notice for Indian Users</h4>
              <p className="desc1 mb-3 text-center">
                UPI is now activated on <b>Weex</b>. You can easily deposit and
                withdraw using UPI with no KYC required.
              </p>
              <p className="desc1 mb-3 text-center">
                Users in the UAE 🇦🇪 can also deposit and withdraw AED directly
                from their bank accounts.
              </p>
              <p className="desc1 mb-3 text-center">
                Don't miss this opportunity —{" "}
                <b> sign up using the link below to get started</b>.
              </p>
              <div className="text-center mb-3">
                <a
                  href="https://www.weex.com/events/promo/otc-20-4?vipCode=z5je&qrType=activity"
                  target="_blank"
                  className="themeBtn"
                  style={{ color: "#fff" }}
                >
                  Join
                </a>
              </div>

              {/* <h4 className="mb-3 text-center">
                Important Update for Group Members
              </h4> */}

              {/* <p className="desc1 mb-2">
                <b> January 14–16:</b> Only one live session will take place at
                11:00 PM (Pakistan Time).
              </p>
              <p className="desc1 mb-2">
                From <b> January 19</b> onward, both live sessions will resume
                at their regular timings.
              </p>
              <p className="desc1 mb-1">Regular LIVE Session Schedule:</p>
              <p className="desc1 mb-1">2 live sessions daily</p>
              <p className="desc1 mb-2">
                <ul>
                  <li>9:00 PM (Pakistan Time)</li>
                  <li>11:00 PM (Pakistan Time)</li>
                </ul>
              </p> */}

              {/* <p className="desc1 mb-3">
                <b>📢 Session Time Update</b>
              </p>
              <p className="desc1 mb-3">Our live session time has changed!</p>
              <p className="desc1 ">
                🕕 New Timing: 9:00 PM PKT & 11:00 PM PKT{" "}
              </p>
              <p className="desc1 mb-3">📅 Days: Monday to Friday</p>
              <p className="desc1 mt-3 ">
                Please note: Saturday and Sunday – No session.
              </p> */}

              {/* <p className="desc1 mt-3  mb-0">
                Thank you for staying with us!{" "}
              </p> */}
              <p className="desc1 text-center">
                <b> Best regards,</b>
              </p>
              <p className="desc1  text-center">
                <b>Team Waqar Zaka.</b>
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
